import { FilledButton } from '../util/button';

interface NextButtonFieldProps {
  disable: boolean;
  onClick: () => void;
}
export const NextButtonField = ({ disable, onClick }: NextButtonFieldProps) => {
  const handleClickNext = () => onClick();
  return (
    <div className={'next-button-field'}>
      <FilledButton
        onClick={handleClickNext}
        label={'次へ'}
        disabled={disable}
      />
    </div>
  );
};
